import * as React from "react";
import {default as MaterialSelect, SelectProps as MaterialSelectProps} from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import {ErrorMessage, useField} from "formik";
import {FormControl, FormHelperText} from "@material-ui/core";
import {useEffect, useRef, useState} from "react";
import {defaultMargins, pickerStyle} from "../styles/field";

export interface PickerOption {
    id: string;
    label: string;
}

export interface PickerPropsWithoutOptions {
    name: string;
    label?: string;
    disabled?: boolean;
    allowEmpty?: boolean;
    emptyValue?: string | number | null;
    emptyValueDescription?: string;
    SelectProps?: MaterialSelectProps;
    helperText?: string;
}

export interface PickerProps extends PickerPropsWithoutOptions {
    options: PickerOption[];
    multiple?: boolean;
}

export default function PickerInput(props: PickerProps) {
    const [field, meta] = useField(props.name);

    const {options, disabled, name, label, allowEmpty, emptyValue, emptyValueDescription, SelectProps, multiple, helperText } = props;

    const inputLabel = useRef<HTMLLabelElement>(null);
    const [labelWidth, setLabelWidth] = useState(0);

    useEffect(() => {
        setLabelWidth(inputLabel.current!.offsetWidth);
    }, []);

    return (
        <FormControl disabled={disabled} style={defaultMargins} variant='outlined' error={!!meta.error && meta.touched}>
            <InputLabel ref={inputLabel} htmlFor={name}>
                {label || ''}
            </InputLabel>
            <MaterialSelect
                labelWidth={labelWidth}
                style={pickerStyle}
                inputProps={{
                    id: name,
                }}
                {...field}
                {...SelectProps}
                multiple={multiple}
            >
                {allowEmpty &&
                <MenuItem key={'empty'} value={emptyValue || ''}>
                    {emptyValueDescription || 'None'}
                </MenuItem>
                }
                {options.map(o =>
                    <MenuItem key={o.id} value={o.id}>
                        {o.label}
                    </MenuItem>
                )}
            </MaterialSelect>
            {helperText && (
                <FormHelperText>{helperText}</FormHelperText>
            )}
            <ErrorMessage name={name}/>
        </FormControl>
    );
}
